import React from 'react';

// Generate a simple error ID for support reference
const generateErrorId = () => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 6);
  return `err_${timestamp}${random}`;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, errorId: generateErrorId() };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error(`[ErrorBoundary] Error ID: ${this.state.errorId}`);
    console.error('[ErrorBoundary] Caught error:', error);
    console.error('[ErrorBoundary] Component stack:', errorInfo?.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null, errorId: null });
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      const isDev = process.env.NODE_ENV === 'development';

      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <div className="error-brand">Ramp.ai</div>

            <h2>Something went wrong</h2>
            <p className="error-message">
              We couldn't complete your request. Don't worry — you haven't been charged.
            </p>

            {isDev && this.state.error && (
              <details className="error-details">
                <summary>Error details (dev only)</summary>
                <pre>{this.state.error.toString()}</pre>
                {this.state.errorInfo?.componentStack && (
                  <pre className="error-stack">{this.state.errorInfo.componentStack}</pre>
                )}
              </details>
            )}

            <div className="error-actions">
              <button onClick={this.handleRetry} className="error-btn error-btn-primary">
                Try again
              </button>
            </div>

            <div className="error-footer">
              {this.state.errorId && <p className="error-id">Error ID: {this.state.errorId}</p>}
              <p className="error-footer-help">
                Having trouble? <a href="mailto:support@rampwithai.com">Contact support</a>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
